import {
  Box,
  FormControl,
  Grid,
  Select,
  Theme,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";
import { Query, Sort } from "../../interfaces";

interface Props {
  updateSort: (newSortField: string, newSortOrder: string) => void;
  appState: Query;
}

const useStyles = makeStyles((theme: Theme) => ({
  selectEmpty: {
    "marginLeft": 10,
    "height": 24,
    "color": "#FFFFFF",
    "background": theme.palette.primary.main,
    "fontSize": 14,
    "& > .MuiNativeSelect-icon": { color: "#FFFFFF" },
    "& .MuiNativeSelect-select.MuiNativeSelect-select": {
      "padding": "0px 32px 0px 0px",
      "&:focus": {
        color: "#ffffff",
        backgroundColor: theme.palette.primary.main,
      },
    },
    "& option": {
      color: theme.palette.primary.main,
    },
  },
  selectEmptyDisabled: {
    "marginLeft": 10,

    "height": 24,
    "background": theme.palette.primary.main,

    "fontSize": 14,
    "& > .MuiNativeSelect-icon": { color: "#91A5C1" },
    "& > .MuiNativeSelect-select.Mui-disabled": {
      "opacity": 0,
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
    },
  },
  sortArea: {
    "background": theme.palette.primary.main,
    "border": 1,
    "borderRadius": 5,
    "height": 24,
    "padding": "16px 24px",
    "& fieldset.MuiOutlinedInput-notchedOutline": {
      border: "0px !important",
    },
    "& .MuiGrid-container": {
      "height": 24,
      "marginTop": -12,
      "& .MuiGrid-item": {
        padding: 0,
      },
    },
  },
  sortText: {
    fontWeight: 700,
    fontSize: 14,
    color: "#FFFFFF",
    padding: 0,
    float: "left",
    lineHeight: "24px",
  },
  sortTextDisabled: {
    "fontWeight": 700,
    "fontSize": 14,
    "color": "#91A5C1",
    "float": "left",
    "lineHeight": "24px",
    "padding": 0,
    "& > .MuiNativeSelect-icon": { color: "#91A5C1" },
  },
}));

export default function BankFindSort({ updateSort, appState }: Props) {
  const classes = useStyles();
  const [sort, setSort] = React.useState<Sort>({
    sortField: "NAME",
    sortOrder: "DESC",
  });
  const sortOrderState = sort.sortOrder;
  const sortFieldState = sort.sortField;

  React.useEffect(() => {
    updateSort("NAME", "DESC");
  }, [updateSort]);
  const handleSortByChange = (event: any) => {
    updateSort(
      event.target.value,
      !event.target.value ? "" : sortOrderState ? sortOrderState : "ASC",
    );
    setSort({
      ...sort,
      sortField: event.target.value,
    });
  };

  const handleSortOrderChange = (event: any) => {
    updateSort(sortFieldState, event.target.value);
    setSort({
      ...sort,
      sortOrder: event.target.value,
    });
  };

  return (
    <Box className={classes.sortArea}>
      <Grid container spacing={2}>
        <Grid item xs={5} md={4}>
          <Typography variant="body2" className={classes.sortText}>
            Sorting:
          </Typography>
          <FormControl>
            <Select
              native
              className={classes.selectEmpty}
              value={sortFieldState}
              name="sort"
              onChange={handleSortByChange}
              id="bankFindSortBy"
            >
              <option value="NAME">Bank Name</option>
              <option value="CERT">Cert</option>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={7} md={8}>
          <Typography
            variant="body2"
            className={
              sortFieldState !== ""
                ? classes.sortText
                : classes.sortTextDisabled
            }
          >
            Order:
          </Typography>
          <FormControl disabled={sortFieldState === ""}>
            <Select
              native
              className={
                sortFieldState !== ""
                  ? classes.selectEmpty
                  : classes.selectEmptyDisabled
              }
              value={sortFieldState === "" ? "" : sortOrderState}
              name="order"
              onChange={handleSortOrderChange}
            >
              <option value="ASC">Ascending</option>
              <option value="DESC">Descending</option>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
